var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "detail-platform-account" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm._m(0),
          _c("platform-account-form", {
            ref: "platformAccountForm",
            attrs: { isDetail: true },
            on: { onHistory: _vm.onHistory },
          }),
          _c(
            "div",
            {
              staticClass: "footer",
              class: [_vm.isCollapsed ? "footer-collapsed" : ""],
            },
            [
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "info", plain: "" },
                    on: { click: _vm.onBack },
                  },
                  [_vm._v("返回")]
                ),
                _vm.permission.delete
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "danger", loading: _vm.btnDelete },
                        on: { click: _vm.onDelete },
                      },
                      [_vm._v("删除")]
                    )
                  : _vm._e(),
                _vm.permission.cancel
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "danger", loading: _vm.btnCancel },
                        on: { click: _vm.onCancel },
                      },
                      [_vm._v("注销账号")]
                    )
                  : _vm._e(),
                _vm.permission.revoke
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          type: "info",
                          plain: "",
                          loading: _vm.btnRevoke,
                        },
                        on: { click: _vm.onRevoke },
                      },
                      [_vm._v("撤销")]
                    )
                  : _vm._e(),
                _vm.permission.transfer
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.btnTransfer },
                        on: { click: _vm.onTransfer },
                      },
                      [_vm._v("转移")]
                    )
                  : _vm._e(),
                _vm.permission.edit
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.btnSave },
                        on: { click: _vm.onSave },
                      },
                      [_vm._v("保存")]
                    )
                  : _vm._e(),
              ],
            ],
            2
          ),
        ],
        1
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "转移", multiple: false },
        on: { ok: _vm.selected },
      }),
      _c("pop-report", {
        ref: "popReport",
        attrs: { reportList: _vm.reportList },
      }),
      _c("pop-cancel", {
        ref: "popCancel",
        attrs: { title: "是否确认注销该平台账号？" },
        on: { setCancel: _vm.setCancel },
      }),
      _c("pop-revoke", {
        ref: "popRevoke",
        attrs: { title: "是否确认撤销该平台账号？" },
        on: { setRevoke: _vm.setRevoke },
      }),
      _c("pop-delete", {
        ref: "popDelete",
        attrs: { title: "是否确认删除？" },
        on: { setDelete: _vm.setDelete },
      }),
      _c("pop-history", { ref: "popHistory", attrs: { title: "历史记录" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "data-title" }, [
      _c("div", { staticClass: "title-name" }, [_vm._v("查看/编辑平台账号")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }